import { fetchConToken } from "../../helpers/fetch";
import { types } from "../../types/types";


import { startSpinner, finishSpinner } from "../ui/spinner";
export const tipoDocumentacionTipoAfiliacionTraerStart = () => ({ type: types.tipoDocumentacionTipoAfiliacionTraerStart });
export const tipoDocumentacionTipoAfiliacionTraerError = (error) => ({ type: types.tipoDocumentacionTipoAfiliacionTraerError,payload: error});
export const tipoDocumentacionTipoAfiliacionTraerSuccess = (payload) => {
  return {
    type: types.tipoDocumentacionTipoAfiliacionTraerSuccess,
    payload: payload
  }
}
//FETCH TIPO DOCUMENTACION TIPO AFILIACION Borrar
export const fetchTipoDocumentacionTipoAfiliacion = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
      dispatch(tipoDocumentacionTipoAfiliacionTraerStart());
    const response = await fetchConToken(`TipoDocumentacionesPorTipoAfiliacion`);
    if (!response.ok) {
        dispatch(
            {
              type: types.tipoDocumentacionTipoAfiliacionTraerError,
              payload: response.statusText,
            }
          );
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length>0) {
        dispatch(tipoDocumentacionTipoAfiliacionTraerSuccess(lista));
      }
    }
    dispatch(finishSpinner());
  };
};
